import React, { useContext } from "react";
import { Card, Accordion, AccordionContext } from "react-bootstrap";
import icons from "../../assets/icons/icons";
import color from "../../assets/colors";

const CustomToggle = ({ eventKey }: any) => {
  const currentEventKey = useContext(AccordionContext);
  const isCurrentEventKey = currentEventKey === eventKey;

  if (isCurrentEventKey) {
    return icons.negetive(color.$black, "");
  } else {
    return icons.plus(color.$black, "");
  }
};

export default function MultiAccordionContents({ data, itemLabel, itemValue }) {
  return (
    <Accordion>
      {data?.map((item: any, i: string) => {
        return (
          <Card key={i}>
            <Accordion.Toggle
              as={Card.Header}
              eventKey={i + 1}
              className="according-header"
            >
              <CustomToggle eventKey={i + 1} /> {item[itemLabel]}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={i + 1}>
              <div className="according-body">{item[itemValue]}</div>
            </Accordion.Collapse>
          </Card>
        );
      })}
    </Accordion>
  );
}
